import { useContext } from 'react';
import { MoviProducaoContextData } from '../types/context';
import { MoviProducaoContext } from '../context/moviProducaoContext';

export const useMoviProducao = (): MoviProducaoContextData =>
  useContext(MoviProducaoContext);
